module.exports = __webpack_public_path__ + "img/地暖.f25d0520.webp";